import type React from "react";
import { useAddProposalSocialHttp } from "../../hooks/http/proposal-socials/add-proposal-social.hook";
import { useParams } from "react-router-dom";
import { PlusIcon } from "lucide-react";
import { handleHttpError } from "../../../utils/utils";
import Button from "../../components/core/button.core";
import { useToast } from "../../../hooks/use-toast";
import useProposalSocialSearchStore from "../../store/proposal-socials-search.store";
import { useUserStore } from "../../../store/user.store";

export const AddSocialToProposal: React.FunctionComponent<{ id: string }> = ({
  id,
}) => {
  const { execute: addProposalSocialHttp, fetching: addingProposalSocial } =
    useAddProposalSocialHttp();
  const { toast } = useToast();
  const { proposalId } = useParams();

  const { setData: setSearchData, data: searchData } =
    useProposalSocialSearchStore();
  const { token } = useUserStore();

  async function addSocialToProposal() {
    if (!token) {
      return toast({
        content: "Please login to add social",
        toastType: "error",
      });
    }
    if (!proposalId) {
      return;
    }
    const response = await addProposalSocialHttp({
      body: {
        social: id,
      },
      pathParams: {
        proposalId,
      },
    });
    if (!response.success) {
      return handleHttpError(response, toast);
    }
    toast({
      content: "Social added to proposal",
      toastType: "success",
    });

    setSearchData(
      searchData.map((item) => {
        if (item.social.id === id) {
          return response.data.campaignProposalSocial;
        }
        return item;
      })
    );
  }

  return (
    <Button
      isLoading={addingProposalSocial}
      onClick={addSocialToProposal}
      className="p-0 w-14 h-14 font-semibold text-black tracking-wider"
    >
      <PlusIcon />
    </Button>
  );
};
